import { ReservationInterface } from 'src/app/core/interfaces/reservations.interfaces';
import { RentalPeriodService } from 'src/app/core/services/rental-period.service';

// Price fields as the CRM reservation JSON sends them. tax_amount is omitted when VAT is empty;
// equipment and coverages carry rental_period inside `charge`, vehicle charges at top level.
interface PriceLine {
  amount?: string | number;
  tax_inclusive?: string;
  tax_amount?: { total?: string | number } | null;
  rental_period?: string;
}

interface ReservationLine extends PriceLine {
  ota_code?: number;
  quantity?: number;
  charge?: PriceLine;
}

const CAR_RENT_OTA_CODE = 1;

/**
 * Reservation total incl. VAT: car rent, other vehicle charges, equipment and coverages.
 * The reservation response has no total field, so it is rebuilt from the line items.
 * Not in the response, so not applied: quantity of vehicle charges and coverages (taken as 1)
 * and per-item max_price caps.
 */
export function reservationTotal(reservation: ReservationInterface, rentalPeriods: RentalPeriodService): number {
  const days = reservation.rental_days;
  const lines: ReservationLine[] = [
    ...(reservation.rental_rate?.vehicle_charges ?? []),
    ...(reservation.equipment ?? []),
    ...(reservation.veh_segment_info?.coverages ?? []),
  ] as ReservationLine[];

  return lines.reduce((total, line) => {
    const price = line.charge ?? line;
    const multiplier = line.ota_code === CAR_RENT_OTA_CODE && !line.charge
      ? days
      : rentalPeriods.getMultiplier(line.rental_period ?? price.rental_period, days);
    return total + priceWithVat(price) * (line.quantity ?? 1) * multiplier;
  }, 0);
}

function priceWithVat(price: PriceLine): number {
  const vat = price.tax_inclusive === 'true' ? 0 : +(price.tax_amount?.total ?? 0);
  return +(price.amount ?? 0) + vat;
}
